// jshint asi: true
// jshint devel: true
// jshint unused:false

function sliders() {

	$('.ticker_JS').slick({
		dots: false,
		speed: 10000,
		arrows: false,
		autoplay: true,
		cssEase: 'linear',
		infinite: true,
		draggable: false,
		autoplaySpeed: 0,
		variableWidth: true,
	})

	$('.carreras_slider_JS').slick({
		fade: true,
		dots: false,
		speed: 300,
		arrows: false,
		autoplay: true,
		draggable: false,
		pauseOnHover: false,
		autoplaySpeed: 3500,
	})
	$('.carreras_slider_dot_JS').click( function(e) {
		e.preventDefault()
		var slide = $(this).data('slide')
		$('.carreras_slider_JS').slick('slickGoTo',slide)
	})

}